import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";

function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const [userName, setUserName] = useState(null);

useEffect(() => {
  const storedUserStr = localStorage.getItem("user");
  if (storedUserStr) {
    try {
      const parsedUser = JSON.parse(storedUserStr);
      setUserName(parsedUser.NAME || parsedUser.UserName || parsedUser.EMAIL || "");
    } catch (e) {
      setUserName(storedUserStr);
    }
  } else {
    setUserName(null);
  }
}, [isOpen]);

  // Sidebar links
  const sidebarLinks = [
    { href: "/admin", label: "Admin" },
    { href: "/summary", label: "Summary" },
    { href: "/deliveryAdmin", label: "Delivery" },
    { href: "/finance", label: "Finance" },
    { href: "/register", label: "Register" },
    { href: "/ChangePassword", label: "Change Password" },
    { href: "/CSAttendance", label: "Attendance" },
    { href: "/fromWhere", label: "From Where" },
    { href: "/EthioProducts", label: "EthioProducts" },
    { href: "/history", label: "History" },
    { href: "/followUp", label: "Follow Up" },
    { href: "/Expenses", label: "Expenses" },
    { href: "/scanner", label: "Scanner" },
  ];
  const sidebarLinksA = [
    { href: "/admin", label: "Admin" },
    { href: "/summary", label: "Summary" },
    { href: "/deliveryAdmin", label: "Delivery" },
    { href: "/finance", label: "Finance" },
    { href: "/register", label: "Register" },
    { href: "/ChangePassword", label: "Change Password" },
    { href: "/history", label: "History" },
    { href: "/CSAttendance", label: "Attendance" },
    { href: "/fromWhere", label: "From Where" },
    { href: "/followUp", label: "Follow Up" },
    { href: "/EthioProducts", label: "EthioProducts" },
    { href: "/scanner", label: "Scanner" },
  ];

  return (
    <>
      {/* Button to toggle sidebar */}
      <button
        className="fixed top-24 left-5 bg-black text-white p-2 z-50 rounded"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <CloseIcon /> : <MenuIcon />}
      </button>

      {/* Sidebar */}
      {userName && userName.toLowerCase().includes("yeabkal") ? (
        <div
          className={`fixed top-20 py-16 left-0 h-full w-3/4 sm:w-1/4 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-40 ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <nav className="flex flex-col pt-30">
            {sidebarLinksA.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="p-4 mx-4 border-b rounded hover:bg-gray-300"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      ) : (
        <div
          className={`fixed top-20 py-16 left-0 h-full w-3/4 sm:w-1/4 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-40 ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <nav className="flex flex-col pt-30">
            {sidebarLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="p-4 mx-4 border-b rounded hover:bg-gray-300"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      )}

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-30"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </>
  );
}

export default Sidebar;
